import { ReactNode } from 'react'

import { CONTENT_MARGIN, CONTENT_MARGIN_COLLAPSED } from './constants'
import { useSideNavigationGlobalState } from './use-side-navigation-global-state'

import styles from './side-navigation-target-content.module.scss';


type Props = {
  children: ReactNode
}

const SideNavigationTargetContent = ({ children }: Props) => {
  const { status, navigationHeight } = useSideNavigationGlobalState()

  const style = {
    marginLeft: status === 'wide' ? CONTENT_MARGIN : CONTENT_MARGIN_COLLAPSED,
    ...(navigationHeight ? { minHeight: navigationHeight } : {}),
  }

  return (
    <div
      className={styles.contentblock}
      style={style}
    >
      {children}
    </div>
  )
}

export default SideNavigationTargetContent
